var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticStyle: { "z-index": "10", display: "inline-block" },
      attrs: {
        "offset-y": "",
        "close-on-content-click": false,
        disabled: _vm.isDisabled
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "k-pagination-options-btn",
                    attrs: { small: "", disabled: _vm.isDisabled },
                    on: { mousedown: _vm.addResizeEventListener }
                  },
                  on
                ),
                [
                  _vm._v("\n      " + _vm._s(_vm.pageSize) + "\n      "),
                  _c("v-icon", { attrs: { color: "link" } }, [
                    _vm._v("arrow_drop_down")
                  ])
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.showDropdown,
        callback: function($$v) {
          _vm.showDropdown = $$v
        },
        expression: "showDropdown"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        { staticClass: "k-sort-filter-menu", attrs: { subheader: "" } },
        [
          _c("v-subheader", [_vm._v("Rows Per Page:")]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.tileClass["5"],
                  attrs: { flat: "", color: "info" },
                  on: {
                    mousedown: function($event) {
                      return _vm.handlePageSizeOptionClick(5)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("5")]),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.tileClass["10"],
                  attrs: {
                    flat: "",
                    color: "info",
                    disabled: _vm.isDisabled_10
                  },
                  on: {
                    mousedown: function($event) {
                      return _vm.handlePageSizeOptionClick(10)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("10")]),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.tileClass["25"],
                  attrs: {
                    flat: "",
                    color: "info",
                    disabled: _vm.isDisabled_25
                  },
                  on: {
                    mousedown: function($event) {
                      return _vm.handlePageSizeOptionClick(25)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("25")]),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.tileClass["50"],
                  attrs: {
                    flat: "",
                    color: "info",
                    disabled: _vm.isDisabled_50
                  },
                  on: {
                    mousedown: function($event) {
                      return _vm.handlePageSizeOptionClick(50)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("50")]),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.tileClass["100"],
                  attrs: {
                    flat: "",
                    color: "info",
                    disabled: _vm.isDisabled_100
                  },
                  on: {
                    mousedown: function($event) {
                      return _vm.handlePageSizeOptionClick(100)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("100")]),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.tileClass["250"],
                  attrs: {
                    flat: "",
                    color: "info",
                    disabled: _vm.isDisabled_250
                  },
                  on: {
                    mousedown: function($event) {
                      return _vm.handlePageSizeOptionClick(250)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("250")]),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.displayAllOption
                ? _c(
                    "v-btn",
                    {
                      class: _vm.tileClass["all"],
                      attrs: { flat: "", color: "info" },
                      on: {
                        mousedown: function($event) {
                          return _vm.handlePageSizeOptionClick("all")
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("All")]),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "k-operation-check-icon",
                          attrs: { color: "primary" }
                        },
                        [_vm._v("check")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }